import { magnetar } from '@/magnetarSetup.js';
import useContext from '@/views/Context/use/useContext';
import { megaContextsModule, contextsModule } from './contextsModule';
import { currentUserId } from '@/store/useAuth';
import { computed, watch } from '@vue/composition-api';
import { Timestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

function pagesDefaults(payload) {
  const defaults = { title: '', id: '' };
  return { ...defaults, ...payload };
}

export const pagesModule = magnetar.collection('pages', {
  modifyPayloadOn: {
    insert: payload => {
      const updated_at = Timestamp.now();
      return { updated_at, ...payload };
    },
    write: payload => {
      const updated_at = Timestamp.now();
      console.log(payload);
      return { updated_at, ...payload };
    }
  }
});
document.pages = pagesModule;
// , {
//   modifyPayloadOn: { insert: payload => pagesDefaults(payload) },
//   modifyReadResponseOn: { added: payload => pagesDefaults(payload) }
// });

export const fetchActiveContextPages = async () => {
  const { activeContextId } = useContext();
  await pagesModule.where('context', '==', activeContextId.value).fetch();
  return;
};

export const subscribeToPages = contextId => {
  // const pageContextIds = contextsModule
  //   .where('version', '==', 2)
  //   .data.values()
  //   .map(x => x.id);
  // const contextsPages = pagesModule
  //   .where('context', 'in', pageContextIds);
  // .where('toDelete', '!=', true);
  // const { activeContextId } = useContext();
  // console.log('get contextsPages', pageContextIds, activeContextId.value);
  // await pagesModule.where('context', '==', activeContextId.value).fetch();
  // console.log('got em');
  //  check permissions
  const auth = getAuth();
  auth.currentUser.getIdTokenResult(true).then(r => console.log(r));
  pagesModule.where('context', '==', contextId).stream();
  // console.log('stream all pages');
  // contextsPages.stream();
  // const getPage = async id => {
  //   console.log('pagePage');
  //   const contextPages = pagesModule.where('context', '==', id);
  //   await contextPages.fetch();
  //   contextPages.stream();
  // };
  // pageContextIds.value.forEach(async id => await getPage(id));
  // watch(pageContextIds, v => {
  //   console.log(v);
  //   v.forEach(id => {
  //     getPage(id);
  //   });
  // });
  // console.log(pageContextIds, magnetar);
  // const contexts = contextsModule.where('version', '==', 2).data.values();
  // const contextIds = contexts.map(c => c.id);
  return;
};

export const getPageModule = pageId => {
  // console.log('get page', pageId);
  return pagesModule.doc(pageId);
};

export const buildBreadcrumbs = (targetPageID, _rootId) => {
  //  get target page
  const targetPage = pagesModule.doc(targetPageID).data;
  //  get page context from that
  const pageDomainId = targetPage.context;
  const pageDomain = contextsModule.doc(pageDomainId).data;
  //  get current user's userPanel
  const rootId = _rootId || pageDomain.userPanels[currentUserId.value];
  // const { activeContextId } = useContext();
  // const rootId = _rootId || contextsModule.doc(activeContextId.value).data.basePage;
  console.log(rootId);
  function progressThroughContext(rootId) {
    let rootPage;
    try {
      // get the root page
      rootPage = pagesModule.doc(rootId).data;
    } catch (e) {
      console.error(e);
      console.log('can not find page', rootId);
      return false;
    }
    if (rootPage == undefined) {
      return false;
    }
    // build an array of all the children pages
    let childrenPageArr = Object.values(rootPage.pageNotes).filter(
      n => n !== undefined && !n.toDelete && n.id && n.type == 'card'
    );
    // childrenPageArr = childrenPageArr.filter(n =>  isNaN(n));

    if (rootId == targetPageID) {
      // we found the right page! Return an empty array to start building back up the chain
      // let rootTitle = rootPage.title.replace(/(<([^>]+)>)/gi, ''); // This strips the HTML tags
      // let breadCrumbElement = {
      //   id: rootId,
      //   title: rootTitle,
      //   type: rootPage.type
      // };

      return []; //returned the breadcrumb element

      //otherwise, call the function on each child to recurse through the whole structure
    } else {
      for (var i = 0; i < childrenPageArr.length; i++) {
        const child = childrenPageArr[i];
        // childrenPageArr.some(child => {
        //for each child, call the recursive function and build an array out of it
        //it'll all be empty arrays until we find the right page ID
        let currChildId = child.pageId;

        const breadCrumbArray = progressThroughContext(currChildId);
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!breadCrumbArray) {
          let rootTitle = rootPage.title.replace(/(<([^>]+)>)/gi, ''); // This strips the HTML tags
          let breadCrumbElement = {
            id: rootId,
            title: rootTitle,
            type: rootPage.type
          };
          breadCrumbArray.push(breadCrumbElement);
          return breadCrumbArray;
        }
        // if (array[i] === 1){
        //   break;
        // }
      }
      // });
    }
  }
  const result = progressThroughContext(rootId) || [];
  console.log(result);
  return result.reverse();
};
